var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { class: ["navigation-container", { expanded: !_vm.isSidebarOpen }] },
          [
            _c("div", [
              _c(
                "div",
                {
                  class: { active: _vm.isActive == "createorder" },
                  on: {
                    click: function ($event) {
                      _vm.isActive = "createorder"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-cart-shopping" }),
                  _vm._v("\n          Create Order\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: { active: _vm.isActive == "payment" },
                  on: {
                    click: function ($event) {
                      _vm.isActive = "payment"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-credit-card" }),
                  _vm._v("\n          Simulate Payment\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: { active: _vm.isActive == "orderstatus" },
                  on: {
                    click: function ($event) {
                      _vm.isActive = "orderstatus"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-box" }),
                  _vm._v("\n          Order Status\n        "),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: ["content bg-light", { expanded: !_vm.isSidebarOpen }] },
          [
            _vm.isActive == "createorder"
              ? _c(
                  "div",
                  [
                    _c("create-order-modal", {
                      on: {
                        "update:status": function ($event) {
                          _vm.isActive = $event
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm.isActive == "payment"
              ? _c(
                  "div",
                  [
                    _c(
                      "b-container",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                        attrs: { fluid: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "content-title" },
                          [
                            _c("b-row", [
                              _c("h1", [_vm._v("Payment Simulation")]),
                            ]),
                            _vm._v(" "),
                            _c("b-row", [
                              _c("span", [
                                _vm._v(
                                  "Create and import payments for testing reconciliation"
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("generate-viban-modal"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-1-1 gap-2rem" }, [
                      _c(
                        "div",
                        { staticClass: "card p-6" },
                        [
                          _c("span", { staticClass: "subtitle" }, [
                            _vm._v("Add Single Payment"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "Create a single payment manually with custom details"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("create-payment-modal", {
                            attrs: { edit: false, payment: {} },
                            on: {
                              "update:payments": function ($event) {
                                return _vm.payments.push($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card p-6" },
                        [
                          _c("span", { staticClass: "subtitle" }, [
                            _vm._v("Bulk Import Payments"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "Import multiple payments at once from a CSV file"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("import-payment-modal", {
                            on: {
                              "update:payments": function ($event) {
                                _vm.payments = _vm.payments.concat($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card p-6" },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c("span", { staticClass: "subtitle" }, [
                              _vm._v(
                                "Payment Queue (" +
                                  _vm._s(
                                    _vm.payments.length +
                                      " payment" +
                                      (_vm.payments.length > 1 ? "s" : "")
                                  ) +
                                  ")"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "btn btn-selection" }, [
                              _vm._v("Valid: " + _vm._s(_vm.payments.length)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.payments.length > 0
                          ? _c("b-table", {
                              staticClass:
                                "table-header-border rounded mt-2rem",
                              staticStyle: { "margin-bottom": "0" },
                              attrs: {
                                responsive: "",
                                hover: "",
                                rounded: "",
                                items: _vm.payments,
                                fields: _vm.paymentsFields,
                                "primary-key": "id",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "cell(status)",
                                    fn: function (data) {
                                      return [
                                        data.item.status == 1
                                          ? _c("i", {
                                              staticClass:
                                                "fa-regular fa-circle-check",
                                              staticStyle: { color: "#00a63e" },
                                            })
                                          : _c("i", {
                                              staticClass:
                                                "fa-regular fa-circle-exclamation",
                                              staticStyle: { color: "#d4183d" },
                                            }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(VIBAN)",
                                    fn: function (data) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(data.item.VIBAN) +
                                              "\n              "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(amount)",
                                    fn: function (data) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            "\n                €" +
                                              _vm._s(
                                                Number(
                                                  data.item.amount
                                                ).toFixed(2)
                                              ) +
                                              "\n              "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(date)",
                                    fn: function (data) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  data.item.date.trim()
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(reference)",
                                    fn: function (data) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(data.item.reference) +
                                              "\n              "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(actions)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              gap: "1rem",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            _c("create-payment-modal", {
                                              attrs: {
                                                edit: true,
                                                payment: data.item,
                                              },
                                              on: {
                                                save: function ($event) {
                                                  return _vm.updatePayment(
                                                    data.item,
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass:
                                                "fa-light fa-trash-can",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removePayment(
                                                    data.item
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1433172847
                              ),
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.payments.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "mt-2rem",
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline-light btn",
                                    on: { click: _vm.clearPayments },
                                  },
                                  [_vm._v("Clear All Payments")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline btn-dark",
                                    on: { click: _vm.submitPayment },
                                  },
                                  [
                                    _vm._v(
                                      "Submit " +
                                        _vm._s(_vm.payments.length) +
                                        " Valid Payments"
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c("div", [
                              _vm.payments.length == 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "drop-zone mt-2rem",
                                      class: { hover: _vm.isDragOver },
                                      on: {
                                        dragover: function ($event) {
                                          $event.preventDefault()
                                        },
                                        dragenter: function ($event) {
                                          $event.preventDefault()
                                          _vm.isDragOver = true
                                        },
                                        dragleave: function ($event) {
                                          $event.preventDefault()
                                          _vm.isDragOver = false
                                        },
                                        drop: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onDrop.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-arrow-up-from-bracket",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("No payments in queue"),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "Add payments manually or import from file"
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                        _vm._v(" "),
                        _vm.isAlertOpen
                          ? _c("alert-modal", [
                              _c("span", [
                                _c("i", {
                                  staticClass: "fa-solid fa-circle-check",
                                }),
                                _vm._v(
                                  "Successfully submitted " +
                                    _vm._s(this.countNewPayments) +
                                    " new payment" +
                                    _vm._s(this.countNewPayments > 1 ? "s" : "")
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-container" }, [
                      _c("span", [_vm._v("How Payment Simulation Works")]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _c("span", [_vm._v("Add Payment:")]),
                          _vm._v(
                            " Create a single payment with a specific VIBAN, amount, date, and reference"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("Import Payments:")]),
                          _vm._v(
                            " Upload a CSV file with multiple payments for batch processing"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("Payment Queue:")]),
                          _vm._v(
                            " Review and edit payments before submission. Both manual and imported payments are added to the queue"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("VIBAN Validation:")]),
                          _vm._v(
                            " Each payment is validated against the VIBAN pool to ensure proper reconciliation"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("Automatic Processing:")]),
                          _vm._v(
                            " After submission, payments appear in the Transaction Ledger and trigger auto-reconciliation"
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("b-container", { attrs: { fluid: "" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "content-title" },
                            [
                              _c("b-row", [_c("h1", [_vm._v("Order Status")])]),
                              _vm._v(" "),
                              _c("b-row", [
                                _c("span", [_vm._v("Track all your orders")]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                gap: "1rem",
                                "align-items": "center",
                              },
                            },
                            [
                              _vm.selectedItems.length > 0
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn-outline btn-tertiary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.exportSelected()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-classic fa-arrow-down-to-line",
                                      }),
                                      _vm._v(
                                        "Export Selected (" +
                                          _vm._s(_vm.selectedItems.length) +
                                          ")"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn-outline button-primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.exportFiltered()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-classic fa-arrow-down-to-line",
                                  }),
                                  _vm._v("Export Filtered"),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn-outline button-primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.exportAll()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-classic fa-arrow-down-to-line",
                                  }),
                                  _vm._v("Export All"),
                                ]
                              ),
                              _vm._v(" "),
                              _c("import-order-modal", {
                                on: { "update:refresh": this.refresh },
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn-outline btn-dark",
                                  staticStyle: {
                                    "background-color": "#155dfc",
                                    border: "none",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.refresh()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class: [
                                      "fa-classic",
                                      "fa-arrows-rotate",
                                      { rotate: _vm.isLoading },
                                    ],
                                  }),
                                  _vm._v(
                                    "\n                Refresh\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card p-6",
                        staticStyle: {
                          display: "grid",
                          "grid-template-columns": "1fr 1fr 1fr 1fr",
                          gap: "1rem",
                        },
                      },
                      [
                        _c("div", { staticStyle: { display: "grid" } }, [
                          _c("span", { staticClass: "filter-item-title" }, [
                            _vm._v("Search"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "filter-item-content",
                            attrs: {
                              type: "text",
                              placeholder: "Order reference, VIBAN, amount...",
                            },
                            on: {
                              input: function (event) {
                                return _vm.searchFilter(event.target.value)
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { display: "grid" } },
                          [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v("Status"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "filter-item-content d-flex justify-content-between py-2 px-3",
                                attrs: { id: "status-picker-link", href: "#" },
                              },
                              [
                                _c("span", { staticClass: "fixed-span-size" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.statusObj.filter(function (item) {
                                          if (
                                            item.code ==
                                            _vm.paginationObj.Status
                                          ) {
                                            return item
                                          }
                                        })[0].label
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa-light fa-chevron-down",
                                  attrs: {
                                    size: "17px",
                                    id: "action-type-chevron",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  target: "status-picker-link",
                                  triggers: "focus",
                                  placement: "bottom",
                                  "custom-class": "popover",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(_vm.statusObj, function (item, index) {
                                    return _c(
                                      "span",
                                      {
                                        key: index,
                                        class: [
                                          "popover-option",
                                          {
                                            "popover-option-selected":
                                              _vm.paginationObj.Status ==
                                              item.code,
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectStatus(item.code)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.label) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { display: "grid" } },
                          [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("From Date")]
                            ),
                            _vm._v(" "),
                            _c("datetime-picker", {
                              staticClass: "z-1",
                              class: {
                                "filter-item-input": true,
                                "filter-item-input-complete": _vm.dateBegin,
                                "error-datepicker": _vm.dateBeginError,
                              },
                              attrs: {
                                format: "DD/MM/YYYY",
                                customInputParentClass: "filter-item-content",
                                maxLength: 19,
                                placeholderValue: _vm.$t(
                                  "common.datetime_picker_empty_date"
                                ),
                                inputIcon: "fa-solid fa-calendar",
                              },
                              on: { input: _vm.selectBeginDate },
                              model: {
                                value: _vm.dateBegin,
                                callback: function ($$v) {
                                  _vm.dateBegin = $$v
                                },
                                expression: "dateBegin",
                              },
                            }),
                            _vm._v(" "),
                            _vm.dateBeginError
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("errors.Data_format_invalid"))
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { display: "grid" } },
                          [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("To Date")]
                            ),
                            _vm._v(" "),
                            _c("datetime-picker", {
                              staticClass: "z-1",
                              class: {
                                "filter-item-input": true,
                                "filter-item-input-complete": _vm.dateEnd,
                                "error-datepicker": _vm.dateEndError,
                              },
                              attrs: {
                                format: "DD/MM/YYYY",
                                customInputParentClass: "filter-item-content",
                                maxLength: 19,
                                placeholderValue: _vm.$t(
                                  "common.datetime_picker_empty_date"
                                ),
                                inputIcon: "fa-solid fa-calendar",
                              },
                              on: { input: _vm.selectEndDate },
                              model: {
                                value: _vm.dateEnd,
                                callback: function ($$v) {
                                  _vm.dateEnd = $$v
                                },
                                expression: "dateEnd",
                              },
                            }),
                            _vm._v(" "),
                            _vm.dateEndError
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("errors.Data_format_invalid"))
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "p-6",
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                gap: "1rem",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("span", { staticClass: "subtitle" }, [
                                _vm._v(
                                  "Orders (" + _vm._s(this.nbTotalResults) + ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Showing " +
                                    _vm._s(_vm.paginationObj.firstIndex) +
                                    " - " +
                                    _vm._s(
                                      _vm.paginationObj.Status != null ||
                                        _vm.paginationObj.search != null ||
                                        _vm.paginationObj.country != null
                                        ? _vm.nbTotalResults <
                                          _vm.paginationObj.maxResults
                                          ? _vm.nbTotalResults
                                          : _vm.currentPage ==
                                            Math.ceil(
                                              _vm.nbTotalResults /
                                                _vm.paginationObj.maxResults
                                            )
                                          ? _vm.nbTotalResults
                                          : _vm.currentPage *
                                            _vm.paginationObj.maxResults
                                        : this.nbTotalResults <
                                          _vm.paginationObj.maxResults
                                        ? this.nbTotalResults
                                        : _vm.currentPage ==
                                          Math.ceil(
                                            _vm.nbTotalResults /
                                              _vm.paginationObj.maxResults
                                          )
                                        ? _vm.nbTotalResults
                                        : _vm.currentPage *
                                          _vm.paginationObj.maxResults
                                    ) +
                                    " of " +
                                    _vm._s(this.nbTotalResults) +
                                    " "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.selectedItems.length > 0
                                ? _c("span", { staticClass: "selected" }, [
                                    _vm._v(
                                      _vm._s(_vm.selectedItems.length) +
                                        " selected"
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedItems.length > 0
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "clear",
                                      on: {
                                        click: function ($event) {
                                          return _vm.clearSelection()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-classic fa-xmark",
                                      }),
                                      _vm._v("Clear"),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                gap: "1rem",
                                "align-items": "center",
                                "text-wrap": "nowrap",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "filter-item",
                                  staticStyle: {
                                    "flex-direction": "row",
                                    display: "flex",
                                    gap: "0.5rem",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("span", [_vm._v("Show: ")]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "filter-item-content d-flex justify-content-between py-2 px-3",
                                      attrs: {
                                        id: "pagination-picker-link",
                                        href: "#",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fixed-span-size" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              this.paginationObj.maxResults
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa-light fa-chevron-down",
                                        attrs: {
                                          size: "17px",
                                          id: "page-chevron",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        target: "pagination-picker-link",
                                        triggers: "focus",
                                        placement: "bottom",
                                        "custom-class": "popover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        _vm._l(
                                          [10, 20, 30, 40, 50],
                                          function (resultsPerPage, index) {
                                            return _c(
                                              "span",
                                              {
                                                key: index,
                                                class: [
                                                  "popover-option",
                                                  {
                                                    "popover-option-selected":
                                                      resultsPerPage ==
                                                      _vm.paginationObj
                                                        .maxResults,
                                                  },
                                                ],
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectPagination(
                                                      resultsPerPage
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(resultsPerPage) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "filter-item-title text-ellipsis",
                                    },
                                    [_vm._v("Per Page")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Last updated: " +
                                    _vm._s(new Date().toLocaleTimeString())
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.orders != null
                        ? _c("div", [
                            _vm.orders.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c("b-table", {
                                      staticClass: "table-header-border mb-0",
                                      attrs: {
                                        responsive: "",
                                        items: _vm.orders,
                                        fields: _vm.fields,
                                        "primary-key": "id",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "head(checkbox)",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-checkbox",
                                                  },
                                                  [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "checkbox",
                                                        id: "all",
                                                        name: "checkAll",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectAll(
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "checkmark",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "cell(checkbox)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-checkbox",
                                                  },
                                                  [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        value: data.item,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleSelection(
                                                            $event,
                                                            data.item
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "checkmark",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(reference)",
                                            fn: function (data) {
                                              return [
                                                data.item.Invoices[0]
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          data.item.Invoices[0]
                                                            .InvoiceIdentifier
                                                        )
                                                      ),
                                                    ])
                                                  : _c("span", [_vm._v("—")]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(amount)",
                                            fn: function (data) {
                                              return [
                                                data.item.Amount
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "€" +
                                                          _vm._s(
                                                            data.item.Amount
                                                          )
                                                      ),
                                                    ])
                                                  : _c("span", [_vm._v("—")]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(VIBAN)",
                                            fn: function (data) {
                                              return [
                                                data.item.VIBAN
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          data.item.VIBAN ==
                                                            "$NotFound"
                                                            ? "—"
                                                            : data.item.VIBAN
                                                        )
                                                      ),
                                                    ])
                                                  : _c("span", [_vm._v("—")]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(status)",
                                            fn: function (data) {
                                              return [
                                                data.item.Status == 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "btn-selection",
                                                        staticStyle: {
                                                          color: "#334155",
                                                          "background-color":
                                                            "#f8fafc",
                                                          "border-color":
                                                            "#e2e8f0",
                                                        },
                                                      },
                                                      [_vm._v("Created")]
                                                    )
                                                  : data.item.Status == 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "btn-selection",
                                                        staticStyle: {
                                                          "border-color":
                                                            "#ffc9c9",
                                                          "background-color":
                                                            "#ffe2e2",
                                                          color: "#9f0712",
                                                        },
                                                      },
                                                      [_vm._v("Not Reconciled")]
                                                    )
                                                  : data.item.Status == 2
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "btn-selection",
                                                        staticStyle: {
                                                          color:
                                                            "rgb(161, 98, 7)",
                                                          "background-color":
                                                            "rgb(254, 252, 232)",
                                                          "border-color":
                                                            "rgb(254, 240, 138)",
                                                        },
                                                      },
                                                      [_vm._v("Partially Paid")]
                                                    )
                                                  : data.item.Status == 3
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "btn-selection",
                                                      },
                                                      [_vm._v("Reconciled")]
                                                    )
                                                  : _c("span", [_vm._v("—")]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(created)",
                                            fn: function (data) {
                                              return [
                                                data.item.Invoices[0]
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.isoToDDMMYYYY(
                                                            data.item
                                                              .Invoices[0]
                                                              .InvoicePaymentDate
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _c("span", [_vm._v("—")]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(actions)",
                                            fn: function (data) {
                                              return [
                                                _c("detail-modal", {
                                                  attrs: { order: data.item },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        46385234
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("hr"),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pagination" }, [
                                      _c(
                                        "button",
                                        {
                                          class: [
                                            "btn-outline-light btn",
                                            { inactive: _vm.currentPage == 1 },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              _vm.currentPage > 1 &&
                                                _vm.previous()
                                            },
                                          },
                                        },
                                        [_vm._v("Previous")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "Page " +
                                            _vm._s(_vm.currentPage) +
                                            " of " +
                                            _vm._s(_vm.totalPages)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          class: [
                                            "btn-outline-light btn",
                                            {
                                              inactive:
                                                _vm.currentPage ==
                                                _vm.totalPages,
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              _vm.currentPage <
                                                _vm.totalPages && _vm.next()
                                            },
                                          },
                                        },
                                        [_vm._v("Next")]
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                        margin: "1rem 0rem",
                                        color: "#6a7282",
                                      },
                                    },
                                    [_vm._v("No orders found")]
                                  ),
                                ]),
                          ])
                        : _c(
                            "div",
                            {
                              staticStyle: { margin: "1rem", color: "#969696" },
                            },
                            [_c("span", [_vm._v("No results found")])]
                          ),
                    ]),
                  ],
                  1
                ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }